export const invoiceAirTicketTags = [
  'AirticketInvoice',
  'NewInvoiceAireTicket',
  'EditInvoiceAireTicket',
];
export const AIRTICKET_LIST = 'AIRTICKET_LIST';
